import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GameLayout.css';
import { IconArrowLeft } from './icons';

export default function GameLayout({ title, subtitle = null, children, rightSlot = null }) {
  const navigate = useNavigate();

  return (
    <div className="gamepage">
      <header className="gamepage-header">
        <button className="gamepage-back" onClick={() => navigate(-1)} aria-label="Back">
          <IconArrowLeft size={20} />
        </button>
        <div className="gamepage-title">
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        <div className="gamepage-right">{rightSlot}</div>
      </header>
      <main className="gamepage-main">
        <div className="gamepage-content">{children}</div>
      </main>
    </div>
  );
}
